export default "__VITE_ASSET__cUTR_drH__"